/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { ClosedEnum } from "../types/enums.js";

/**
 * 排序方式
 */
export const PostSearchAggregateSort = {
  Relevance: "relevance",
  Date: "date",
} as const;
/**
 * 排序方式
 */
export type PostSearchAggregateSort = ClosedEnum<
  typeof PostSearchAggregateSort
>;

export const PostSearchAggregateSort$zodSchema = z.enum([
  "relevance",
  "date",
]).describe("排序方式");

/**
 * 时间范围过滤
 */
export const TimeRange = {
  Day: "day",
  Week: "week",
  Month: "month",
  Year: "year",
} as const;
/**
 * 时间范围过滤
 */
export type TimeRange = ClosedEnum<typeof TimeRange>;

export const TimeRange$zodSchema = z.enum([
  "day",
  "week",
  "month",
  "year",
]).describe("时间范围过滤");

/**
 * 包含搜索参数的JSON对象
 */
export type PostSearchAggregateRequest = {
  query: string;
  site?: string | undefined;
  filetype?: string | undefined;
  fetch_full?: boolean | undefined;
  timeout_ms?: number | undefined;
  sort?: PostSearchAggregateSort | undefined;
  time_range?: TimeRange | undefined;
};

export const PostSearchAggregateRequest$zodSchema: z.ZodType<
  PostSearchAggregateRequest
> = z.object({
  fetch_full: z.boolean().default(false),
  filetype: z.string().optional(),
  query: z.string(),
  site: z.string().optional(),
  sort: PostSearchAggregateSort$zodSchema.default("relevance"),
  time_range: TimeRange$zodSchema.optional(),
  timeout_ms: z.int().default(8000),
}).describe("包含搜索参数的JSON对象");

/**
 * 服务器内部错误
 */
export type PostSearchAggregateInternalServerErrorResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
  timestamp?: string | undefined;
};

export const PostSearchAggregateInternalServerErrorResponseBody$zodSchema:
  z.ZodType<PostSearchAggregateInternalServerErrorResponseBody> = z.object({
    code: z.string().optional(),
    message: z.string().optional(),
    timestamp: z.iso.datetime({ offset: true }).optional(),
  }).describe("服务器内部错误");

/**
 * 请求过于频繁
 */
export type PostSearchAggregateTooManyRequestsResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
  timestamp?: string | undefined;
};

export const PostSearchAggregateTooManyRequestsResponseBody$zodSchema:
  z.ZodType<PostSearchAggregateTooManyRequestsResponseBody> = z.object({
    code: z.string().optional(),
    message: z.string().optional(),
    timestamp: z.iso.datetime({ offset: true }).optional(),
  }).describe("请求过于频繁");

/**
 * 未授权
 */
export type PostSearchAggregateUnauthorizedResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
  timestamp?: string | undefined;
};

export const PostSearchAggregateUnauthorizedResponseBody$zodSchema: z.ZodType<
  PostSearchAggregateUnauthorizedResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
  timestamp: z.iso.datetime({ offset: true }).optional(),
}).describe("未授权");

/**
 * 请求参数错误
 */
export type PostSearchAggregateBadRequestResponseBody = {
  code?: string | undefined;
  message?: string | undefined;
  timestamp?: string | undefined;
};

export const PostSearchAggregateBadRequestResponseBody$zodSchema: z.ZodType<
  PostSearchAggregateBadRequestResponseBody
> = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
  timestamp: z.iso.datetime({ offset: true }).optional(),
}).describe("请求参数错误");

export type PostSearchAggregateResult = {
  title?: string | undefined;
  url?: string | undefined;
  snippet?: string | undefined;
  domain?: string | undefined;
  source?: string | undefined;
  position?: number | undefined;
  score?: number | undefined;
  publish_time?: string | undefined;
  author?: string | null | undefined;
};

export const PostSearchAggregateResult$zodSchema: z.ZodType<
  PostSearchAggregateResult
> = z.object({
  author: z.string().nullable().optional(),
  domain: z.string().optional(),
  position: z.int().optional(),
  publish_time: z.iso.datetime({ offset: true }).optional(),
  score: z.number().optional(),
  snippet: z.string().optional(),
  source: z.string().optional(),
  title: z.string().optional(),
  url: z.string().optional(),
});

export type PostSearchAggregateSource = {
  name?: string | undefined;
  status?: string | undefined;
  result_count?: number | undefined;
  elapsed_ms?: number | undefined;
  first_result_host?: string | undefined;
};

export const PostSearchAggregateSource$zodSchema: z.ZodType<
  PostSearchAggregateSource
> = z.object({
  elapsed_ms: z.int().optional(),
  first_result_host: z.string().optional(),
  name: z.string().optional(),
  result_count: z.int().optional(),
  status: z.string().optional(),
});

/**
 * 搜索成功，返回经过AI排序的高质量结果
 */
export type PostSearchAggregateResponseBody = {
  query?: string | undefined;
  total_results?: number | undefined;
  results?: Array<PostSearchAggregateResult> | undefined;
  sources?: Array<PostSearchAggregateSource> | undefined;
  process_time_ms?: number | undefined;
  cached?: boolean | undefined;
};

export const PostSearchAggregateResponseBody$zodSchema: z.ZodType<
  PostSearchAggregateResponseBody
> = z.object({
  cached: z.boolean().optional(),
  process_time_ms: z.int().optional(),
  query: z.string().optional(),
  results: z.array(z.lazy(() => PostSearchAggregateResult$zodSchema))
    .optional(),
  sources: z.array(z.lazy(() => PostSearchAggregateSource$zodSchema))
    .optional(),
  total_results: z.int().optional(),
}).describe("搜索成功，返回经过AI排序的高质量结果");

export type PostSearchAggregateResponse =
  | PostSearchAggregateResponseBody
  | PostSearchAggregateBadRequestResponseBody
  | PostSearchAggregateUnauthorizedResponseBody
  | PostSearchAggregateTooManyRequestsResponseBody
  | PostSearchAggregateInternalServerErrorResponseBody;

export const PostSearchAggregateResponse$zodSchema: z.ZodType<
  PostSearchAggregateResponse
> = z.union([
  z.lazy(() => PostSearchAggregateResponseBody$zodSchema),
  z.lazy(() => PostSearchAggregateBadRequestResponseBody$zodSchema),
  z.lazy(() => PostSearchAggregateUnauthorizedResponseBody$zodSchema),
  z.lazy(() => PostSearchAggregateTooManyRequestsResponseBody$zodSchema),
  z.lazy(() => PostSearchAggregateInternalServerErrorResponseBody$zodSchema),
]);
